export default __webpack_public_path__ + "5578a40d8d7808b91ad635f510920ed4.png";